import script from "./OpenOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenOrders.vue?vue&type=script&setup=true&lang=js"

import "./OpenOrders.vue?vue&type=style&index=0&id=2a32997d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a32997d"]])

export default __exports__